/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_Zh_ContentInputs */

const en_directory_submit_enrich_stage_zh_content = /** @type {(inputs: Directory_Submit_Enrich_Stage_Zh_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate (core)`)
};

const zh_directory_submit_enrich_stage_zh_content = /** @type {(inputs: Directory_Submit_Enrich_Stage_Zh_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文翻译（正文）`)
};

/**
* | output |
* | --- |
* | "Translate (core)" |
*
* @param {Directory_Submit_Enrich_Stage_Zh_ContentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_zh_content = /** @type {((inputs?: Directory_Submit_Enrich_Stage_Zh_ContentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_Zh_ContentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_zh_content(inputs)
	return zh_directory_submit_enrich_stage_zh_content(inputs)
});
export { directory_submit_enrich_stage_zh_content as "directory.submit.enrich.stage.zh_content" }